"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_router_dom_1 = require("react-router-dom");
const react_1 = __importStar(require("react"));
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
const Cad3d_1 = __importDefault(require("~/components/Cad3d"));
const ViewCube_1 = __importDefault(require("~/components/ViewCube"));
const ToolboxPanel_1 = __importDefault(require("~/components/ToolboxPanel"));
const ContextMenu_1 = __importDefault(require("~/components/ContextMenu"));
const WidgetsManager_1 = __importDefault(require("~/components/WidgetsManager"));
const NotificationsManager_1 = __importDefault(require("~/components/NotificationsManager"));
const EventsHandler_1 = __importDefault(require("~/components/EventsHandler"));
const Modal_1 = __importDefault(require("~/components/common/Modal"));
const BundleVersionWidget_1 = __importDefault(require("~/components/UI/BundleVersionWidget"));
const actions_1 = require("~/store/actions");
const consts_1 = require("~/store/consts");
const selectors_1 = require("~/store/selectors");
const useProjectStatus_1 = __importDefault(require("~/hooks/useProjectStatus"));
const useProjectItemPath_1 = __importDefault(require("~/hooks/useProjectItemPath"));
const getProjectId_1 = __importDefault(require("~/utils/getProjectId"));
const react_helmet_async_1 = require("react-helmet-async");
const routes_1 = require("~/consts/routes");
const GoogleAnalytics_1 = __importDefault(require("~/components/UI/GoogleAnalytics"));
const consts_2 = require("~/consts/consts");
const projectSharing_1 = require("~/utils/projectSharing");
const utils_1 = require("~/utils/utils");
function Cad3dPage() {
    const [modals, setModals] = (0, react_1.useState)([]);
    const viewerRef = (0, react_1.useRef)(null);
    const projectId = (0, getProjectId_1.default)();
    const isProjectItemPath = (0, useProjectItemPath_1.default)(projectId);
    const { isOrderCompleted, isProjectArchived, isProjectViewOnly } = (0, useProjectStatus_1.default)();
    const currentProject = (0, react_redux_1.useSelector)(selectors_1.selectCurrentProject);
    const currentUser = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUser);
    const isUserLogged = (0, react_redux_1.useSelector)(selectors_1.selectIsUserLogged);
    (0, projectSharing_1.getProjectShareToken)(projectId);
    const location = (0, react_router_dom_1.useLocation)();
    const { pathname } = location;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { dispatchInitPersistentWidgets, dispatchToggleWidget, dispatchUndos, dispatchRedos, dispatchGetCurrentProject, dispatchValidateTokenAction, dispatchSetDiscountedPriceShown, } = (0, redux_1.bindActionCreators)({
        dispatchInitPersistentWidgets: actions_1.initPersistentWidgets,
        dispatchToggleWidget: actions_1.toggleWidget,
        dispatchUndos: actions_1.updateUndos,
        dispatchRedos: actions_1.updateRedos,
        dispatchGetCurrentProject: actions_1.getCurrentProject,
        dispatchValidateTokenAction: actions_1.validateTokenAction,
        dispatchSetDiscountedPriceShown: actions_1.setDiscountedPriceShown,
    }, (0, react_redux_1.useDispatch)());
    (0, react_1.useEffect)(() => {
        if (projectId && !Number.isNaN(projectId) && isUserLogged && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id)) {
            const optionHandlerMatch = (0, react_router_dom_1.matchPath)('/projects/:id', window.location.pathname);
            dispatchGetCurrentProject({ projectId, optionHandlerMatch: !!optionHandlerMatch });
        }
        dispatchInitPersistentWidgets();
    }, [projectId, isUserLogged, currentUser === null || currentUser === void 0 ? void 0 : currentUser.id]);
    (0, react_1.useEffect)(() => {
        if (isProjectItemPath) {
            dispatchToggleWidget({
                widgetName: consts_1.WIDGETS.CATALOG_WIDGET,
                show: !(isOrderCompleted || isProjectArchived || isProjectViewOnly),
            });
        }
    }, [isProjectItemPath, isOrderCompleted, isProjectArchived, isProjectViewOnly]);
    (0, react_1.useEffect)(() => {
        if (!projectId && !(0, utils_1.getToken)())
            return;
        dispatchValidateTokenAction(() => {
            if (projectId) {
                sessionStorage.setItem('project-share-return', `/projects/${projectId}`);
            }
            navigate(routes_1.ROUTE_LOGIN);
        });
    }, [projectId]);
    (0, react_1.useEffect)(() => {
        const storedValue = localStorage.getItem(consts_2.DISCOUNTED_PRICE_SHOWN_KEY);
        dispatchSetDiscountedPriceShown(storedValue ? JSON.parse(storedValue) : false);
    }, []);
    const contextMenu = (0, react_redux_1.useSelector)(selectors_1.selectContextMenu);
    const updateHistoryControls = (undos, redos) => {
        dispatchUndos(undos.length);
        dispatchRedos(redos.length);
    };
    const zoomViewerToFit = () => {
        var _a, _b;
        (_a = viewerRef.current) === null || _a === void 0 ? void 0 : _a.zoomToFit((_b = viewerRef.current) === null || _b === void 0 ? void 0 : _b.maybeAllPartsBoundingBox());
    };
    const zoomViewerIn = () => {
        var _a;
        (_a = viewerRef.current) === null || _a === void 0 ? void 0 : _a.zoomIn();
    };
    const zoomViewerOut = () => {
        var _a;
        (_a = viewerRef.current) === null || _a === void 0 ? void 0 : _a.zoomOut();
    };
    const toggleViewCube = (cameraView) => {
        var _a;
        (_a = viewerRef.current) === null || _a === void 0 ? void 0 : _a.toggleViewCube(cameraView);
    };
    const undoAction = () => {
        var _a;
        (_a = viewerRef.current) === null || _a === void 0 ? void 0 : _a.getDesignProMain().undoCommand();
    };
    const redoAction = () => {
        var _a;
        (_a = viewerRef.current) === null || _a === void 0 ? void 0 : _a.getDesignProMain().redoCommand();
    };
    const unselectObjectInViewer = () => {
        var _a;
        (_a = viewerRef.current) === null || _a === void 0 ? void 0 : _a.getDesignProMain().selectionTool.unselectAll();
    };
    const deleteObjectInViewer = () => {
        var _a, _b, _c, _d;
        const objectUuid = (_a = viewerRef.current) === null || _a === void 0 ? void 0 : _a.selectedObjects[0].uuid;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
        (_b = viewerRef.current) === null || _b === void 0 ? void 0 : _b.getDesignProMain().selectionTool.unselectObject((_c = viewerRef.current) === null || _c === void 0 ? void 0 : _c.getObjectById(objectUuid));
        (_d = viewerRef.current) === null || _d === void 0 ? void 0 : _d.getDesignProMain().removeObjects([objectUuid]);
    };
    const deleteObjectsInViewer = () => {
        var _a, _b, _c;
        if ((_a = contextMenu.selectedIds) === null || _a === void 0 ? void 0 : _a.length) {
            (_b = viewerRef.current) === null || _b === void 0 ? void 0 : _b.getDesignProMain().removeObjects(contextMenu.selectedIds);
        }
        (_c = viewerRef.current) === null || _c === void 0 ? void 0 : _c.getDesignProMain().selectionTool.unselectAll();
    };
    const copyObjectInViewer = () => {
        var _a, _b;
        (_a = viewerRef.current) === null || _a === void 0 ? void 0 : _a.getDesignProMain().copyAction();
        (_b = viewerRef.current) === null || _b === void 0 ? void 0 : _b.getDesignProMain().pasteAction();
    };
    const refreshScene = () => {
        var _a;
        (_a = viewerRef.current) === null || _a === void 0 ? void 0 : _a.getDesignProMain().refreshScene();
    };
    const toggleWidgets = (action) => {
        var _a;
        if (action.widgetName === consts_1.WIDGETS.RECOMMENDED_FASTENERS_WIDGET && !action.show) {
            (_a = viewerRef.current) === null || _a === void 0 ? void 0 : _a.setFastenersDefaultStyle();
        }
    };
    const numberOfFasteners = () => {
        var _a;
        return ((_a = viewerRef.current) === null || _a === void 0 ? void 0 : _a.getNumberOfFasteners()) || 0;
    };
    const projectRegex = /^\/projects\/\d+$/;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        (pathname === '/' || projectRegex.test(pathname)) && (react_1.default.createElement(react_helmet_async_1.Helmet, null,
            react_1.default.createElement("title", null, currentProject ? `${currentProject.name} | TBUILD` : 'WHAT DO YOU WANT TO BUILD TODAY? | TBUILD'),
            react_1.default.createElement("meta", { name: "description", content: "Revolutionize your t-slotted design experience with TBUILD! TSLOTS' new design software is an intuitive, easy-to-use web-based tool that allows you to create and edit designs, print a bill of materials, and get real-time pricing for your aluminum extrusion project. WHAT DO YOU WANT TO BUILD TODAY?" }))),
        react_1.default.createElement(Cad3d_1.default, { viewerRef: viewerRef, modals: modals, updateHistoryControls: updateHistoryControls }),
        react_1.default.createElement(ToolboxPanel_1.default, { zoomViewerToFit: zoomViewerToFit, zoomViewerIn: zoomViewerIn, zoomViewerOut: zoomViewerOut, undoAction: undoAction, redoAction: redoAction, unselectObjectInViewer: unselectObjectInViewer, numberOfFasteners: numberOfFasteners, toggleWidgets: toggleWidgets }),
        react_1.default.createElement(ViewCube_1.default, { toggleViewCube: toggleViewCube }),
        react_1.default.createElement(BundleVersionWidget_1.default, null),
        react_1.default.createElement(ContextMenu_1.default, { deleteObjectInViewer: deleteObjectInViewer, deleteObjectsInViewer: deleteObjectsInViewer, copyObjectInViewer: copyObjectInViewer, isViewMode: isProjectViewOnly }),
        react_1.default.createElement(WidgetsManager_1.default, { toggleWidgets: toggleWidgets }),
        react_1.default.createElement(Modal_1.default, { modals: modals, setModals: setModals }),
        react_1.default.createElement(NotificationsManager_1.default, null),
        react_1.default.createElement(EventsHandler_1.default, { refreshSceneHandler: refreshScene }),
        react_1.default.createElement(GoogleAnalytics_1.default, null)));
}
exports.default = Cad3dPage;
